export default __webpack_public_path__ + "static/media/cocina-mobile.51396e4e.png";